import Component from "gia/Component";
import gsap from "gsap";
import { slugify } from "../utils/utils";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.makeAnchors();
  }

  makeAnchors() {
    this.DOM.titles = this.DOM.view.querySelectorAll("h2");
    for (let [k, title] of this.DOM.titles.entries()) {
      const getHTML = title.innerHTML;
      const pos = k + 1;
      const number = pos.toString().padStart(2, "0");
      const slug = slugify(getHTML);
      title.setAttribute("id", slug);
      const numberTag = document.createElement("span");
      numberTag.classList.add("util-page-title-number");
      numberTag.innerHTML = "(" + number + ")";
      title.appendChild(numberTag);

      let entry = document.createElement("li");
      entry.classList.add("util-headtype-h5");
      entry.classList.add("tw-mb-2");
      entry.classList.add("util-page-anchor");

      entry.innerHTML = `<a href="#${slug}">(${number + ") " + getHTML}`;
      this.ref.anchors[0].appendChild(entry);
    }
  }

  unmount() {}
}
